module.exports = __webpack_public_path__ + "img/flag_uz_medium.dbcb3a53.png";